import { createAction, props } from '@ngrx/store';
import { IGenerateV1DRequest } from '../models/generate-v1d-request.model';
import { IGenerateV1DResponse } from '../models/generate-v1d-response.model';

export const generateV1DFile = createAction(
  '[Outstanding] Generate V1D File',
  props<{
    request: IGenerateV1DRequest;
  }>()
);

export const generateV1DFileSuccess = createAction(
  '[Outstanding] Generate V1D File Success',
  props<{ response: IGenerateV1DResponse }>()
);

export const generateV1DFileFailure = createAction(
  '[Outstanding] Generate V1D File Failure',
  props<{ error: Error | any }>()
);
